import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Box,
  MenuItem,
  Paper,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEndorsmentFormData,
  updateEndorsementFormData,
} from 'src/features/rfqDataSlice';
import { selectOccupancy } from 'src/features/staticDataSlice';

const FireFloaterEditable = ({ sectionId }) => {
  const dispatch = useDispatch();
  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const occupancyList = useSelector(selectOccupancy);

  const sectionData = endorsementFormData?.sumInsuredSectionData?.[sectionId] || {};
  const fireData = sectionData?.fireFloaterData;
   const hasFireFloaterSelection = fireData?.istotalSumInsuredSelected || fireData?.isfireFloaterOccupancySelected;

  if (!fireData) return null;

  const handleChange = (field, value) => {
    const latestSection =
      endorsementFormData?.sumInsuredSectionData?.[sectionId] || {};

    const latestFloater =
      latestSection?.fireFloaterData || {};

    dispatch(
      updateEndorsementFormData({
        sumInsuredSectionData: {
          ...endorsementFormData.sumInsuredSectionData,
          [sectionId]: {
            ...latestSection,
            fireFloaterData: {
              ...latestFloater,
              [field]: value,
            },
          },
        },
      })
    );
  };

  return (
    <div style={{ marginTop: 1 }}>
      {/* Header Row */}
      {hasFireFloaterSelection && <Grid
        container
        sx={{
          backgroundColor: '#f5f5f5',
          p: 1,
          fontWeight: 'bold',
        }}
      >
        <Grid item xs={4}>
          <Typography fontWeight="bold">Field</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontWeight="bold" color="error">
            Old Value
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontWeight="bold" color="green">
            New Value
          </Typography>
        </Grid>
      </Grid>}


      {/* OCCUPANCY ROW */}
      {fireData?.isfireFloaterOccupancySelected && (
        <Grid container alignItems="center" sx={{ p: .5, borderTop: '1px solid #eee' }}>
          <Grid item xs={4}>
            <Typography>Occupancy</Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography color="error">
              {fireData?.fireFloaterOccupancy}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <TextField
              select
              fullWidth
              size="small"
              value={fireData?.fireFloaterOccupancyNewValue || ''}
              onChange={(e) =>
                handleChange(
                  'fireFloaterOccupancyNewValue',
                  e.target.value
                )
              }
            >
              {occupancyList?.map((item) => (
                <MenuItem
                  key={item.occupancyName}
                  value={item.occupancyName}
                >
                  {item.occupancyName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      )}

      {/* TOTAL SUM INSURED ROW */}
      {fireData?.istotalSumInsuredSelected && (
        <Grid container alignItems="center" sx={{ p: .5, borderTop: '1px solid #eee' }}>
          <Grid item xs={4}>
            <Typography>Total Sum Insured</Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography color="error">
              {fireData?.totalSumInsured}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <TextField
              type="number"
              fullWidth
              size="small"
              value={fireData?.totalSumInsuredNewValue || ''}
              onChange={(e) =>
                handleChange(
                  'totalSumInsuredNewValue',
                  e.target.value
                )
              }
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default FireFloaterEditable;